/* eslint-disable max-len */
import types from '../types'

const initialState = {
  /* Default values here */
  theme: 'dark',
  isAcquiPathSelectShowing: true,
  selectedSectionIndex: 0,
  selectedSubSectionIndex: 0,
  savesProgress: true,
  chatHistory: [],
  documents: {},
  step: 'splash',
  isResourcesModal: false,
  isResourcesModalShowing: false,
  isResourcesPage: false,
  isLoading: false,
  chatFeed: [],
  promptPreamble: 'You are RikY-Chat, and you are used in demos for a new product called "ALFRED". If you are asked "Who are you?" you should answer only "I am ALFRED, an artificial intelligence specifically designed to streamline the defense acquisition process for the Department of Defense."',
  searchSize: 15,
  storedChats: [],
}

export default function(state = initialState, action) {
  switch (action.type) {
    case types.STORE_PAYLOAD:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}
